import { BITTE_BLACK_IMG } from '../../lib/images';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';

const IMAGE_API =
  'https://image-cache-service-z3w7d7dnea-ew.a.run.app/media?url=';

export const MarkdownTable = ({ content }: { content: string }) => {
  // Split the markdown string into lines
  const lines = content.split('\n');

  // Filter out the lines that are part of the table
  const tableLines = lines.filter(
    (line) => line.startsWith('|') && !line.includes('---'),
  );

  // Split each line into cells
  const cells = tableLines.map((line) =>
    line
      .split('|')
      .slice(1, -1)
      .map((cell) => cell.trim()),
  );

  return (
    <Table className="bitte-mt-4 bitte-w-full bitte-border bitte-border-gray-600 bitte-rounded-lg">
      <TableHeader>
        <TableRow className="bitte-border-b bitte-border-gray-600 bitte-bg-gray-800/50 hover:bitte-bg-gray-800/70">
          {cells[0].map((header, index) => (
            <TableHead
              key={index}
              className="bitte-px-4 bitte-py-3 bitte-text-left bitte-text-sm bitte-font-semibold bitte-text-gray-200 bitte-border-r bitte-border-gray-600 last:bitte-border-r-0"
            >
              {header}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {cells.slice(1).map((row, rowIndex) => (
          <TableRow
            key={rowIndex}
            className="bitte-border-b bitte-border-gray-700 hover:bitte-bg-gray-800/30 last:bitte-border-b-0"
          >
            {row.map((cell, cellIndex) => {
              // Enhanced link detection - support multiple link formats
              const markdownLinkMatch = cell.match(/\[([^\]]+)\]\(([^)]+)\)/);
              const plainUrlMatch = cell.match(/(https?:\/\/[^\s]+)/);
              const linkValue = markdownLinkMatch?.[2] || plainUrlMatch?.[1];
              const linkText = markdownLinkMatch?.[1] || linkValue;

              const imageMatchQuery = cell.match(/!\[.*\]\((.*)\)/);
              const imageMatch = imageMatchQuery?.[1];
              const imageValue = imageMatch?.startsWith('https://')
                ? imageMatch
                : BITTE_BLACK_IMG;

              return (
                <TableCell
                  key={cellIndex}
                  className="bitte-px-4 bitte-py-3 bitte-text-left bitte-align-top bitte-text-white bitte-border-r bitte-border-gray-600 last:bitte-border-r-0"
                >
                  <div className="bitte-break-words">
                    {linkValue ? (
                      markdownLinkMatch ? (
                        <span>
                          {cell.replace(markdownLinkMatch[0], '')}{' '}
                          <a
                            href={linkValue}
                            target="_blank"
                            rel="noreferrer"
                            className="bitte-text-blue-300 hover:bitte-text-blue-200 bitte-underline"
                          >
                            {linkText}
                          </a>
                        </span>
                      ) : (
                        <a
                          href={linkValue}
                          target="_blank"
                          rel="noreferrer"
                          className="bitte-text-blue-300 hover:bitte-text-blue-200 bitte-underline"
                        >
                          {linkValue.length > 50
                            ? linkValue.substring(0, 50) + '...'
                            : linkValue}
                        </a>
                      )
                    ) : imageMatch ? (
                      <div className="bitte-relative bitte-h-24 bitte-w-24">
                        <img
                          src={`${IMAGE_API}${imageValue}`}
                          alt={`result-${cellIndex}`}
                        />
                      </div>
                    ) : (
                      <div>{cell}</div>
                    )}
                  </div>
                </TableCell>
              );
            })}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
